<template><div></div></template>

<script setup lang="ts">
document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".header-navigation-toggle");
  const nav = document.querySelector(".header-navigation-nav");
  const overlay = document.querySelector(".header-navigation-overlay");

  const closeMenu = () => {
    if (toggle && nav && overlay) {
      toggle.setAttribute("aria-expanded", "false");
      nav.setAttribute("aria-expanded", "false");
      overlay.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
  };

  const openMenu = () => {
    if (toggle && nav && overlay) {
      toggle.setAttribute("aria-expanded", "true");
      nav.setAttribute("aria-expanded", "true");
      overlay.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      window.addEventListener("resize", () => {
        if (
          window.innerWidth > 600 &&
          toggle.getAttribute("aria-expanded") === "true"
        ) {
          closeMenu();
        }
      });
    }
  };

  const headerContainer = document.querySelector(
    ".header-navigation-container"
  );
  if (headerContainer) {
    window.addEventListener("scroll", () => {
      headerContainer.classList.toggle("is-scrolled", window.scrollY > 0);
    });
  }

  if (toggle && nav && overlay) {
    toggle.addEventListener("click", () => {
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Close menu when clicking overlay
    overlay.addEventListener("click", closeMenu);

    // Close menu when clicking a nav link on mobile
    nav.addEventListener("click", (e) => {
      if (
        e.target instanceof HTMLElement &&
        e.target.closest(".header-navigation-link")
      ) {
        if (window.innerWidth <= 600) {
          closeMenu();
        }
      }
    });

    // Close menu on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && nav.getAttribute("aria-expanded") === "true") {
        closeMenu();
      }
    });
  }
});
</script>
